import { Link } from "react-router-dom";
import { logo, menu } from "assets/icons/index";
import { useState } from "react";
import MobileMenu from "./MobileMenu";

interface SiteLogoProps {}

const SiteLogo = ({}: SiteLogoProps) => {
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  return (
    <section className="flex items-center">
      {/* burger menu  */}
      <div className="lg:hidden min-w-[40px] w-[40px] cursor-pointer">
        <img
          onClick={() => setShowMobileMenu(!showMobileMenu)}
          src={menu}
          alt=""
        />
      </div>

      {/* logo */}
      <Link
        to={"/"}
        className="w-[100px] lg:w-[150px] flex items-center justify-center"
      >
        <img src={logo} alt="logo" />
      </Link>

      {/* mobile menu  */}
      {showMobileMenu ? (
        <MobileMenu show={showMobileMenu} setShow={setShowMobileMenu} />
      ) : (
        ""
      )}
    </section>
  );
};

export default SiteLogo;
